import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import SubSectionBar from '../SubSectionBar/SubSectionBar';
import ContentContainer from '../ContentContainer/ContentContainer';
import { parseLocationToPath } from '../../utils';
import { getSubsection } from '../../redux/actions';

const WithSubsections = ({ section, color, onBackToTop }) => {
  const location = useLocation();
  const subsections = useSelector((state) => state.subsection.subsections);
  const dispatch = useDispatch();
  const currentPath = parseLocationToPath(location);
  useEffect(() => {
    if (!subsections[currentPath]) {
      dispatch(getSubsection(currentPath));
    }
  }, [currentPath, dispatch, subsections]);
  return (
    <>
      <SubSectionBar subsections={section.subsections} color={color} />
      {subsections[currentPath] && (
        <ContentContainer
          description={subsections[currentPath].description}
          color={color}
          allContent={subsections[currentPath].contents}
          onBackToTop={onBackToTop}
        />
      )}
    </>
  );
};

WithSubsections.propTypes = {
  section: PropTypes.shape({
    subsections: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  }).isRequired,
  color: PropTypes.string.isRequired,
  onBackToTop: PropTypes.func,
};
WithSubsections.defaultProps = {
  onBackToTop: () => {},
};

export default WithSubsections;
